<template>
  <b-sidebar
    id="sidebar-service-description-setup-filters"
    sidebar-class="sidebar-lg"
    :visible="isFilterSidebarActive"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
    @change="(val) => $emit('update:is-filter-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Filters
        </h5>
        <feather-icon
          class="cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <div class="px-2 py-1">
        <b-form-group label="Appointment Types">
          <b-form-checkbox-group
            v-model="selectedAppointmentTypes"
            stacked
          >
            <b-form-checkbox
              v-for="option in appointmentTypeOptions"
              :key="option._id"
              :value="option._id"
            >
              {{ option.typeName }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>

        <hr>

        <b-form-group label="Service Types">
          <b-form-checkbox-group
            v-model="selectedServiceTypes"
            stacked
          >
            <b-form-checkbox
              v-for="option in serviceTypeOptions"
              :key="option._id"
              :value="option._id"
            >
              {{ option.name }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>

        <hr>

        <b-form-group
          label="Status"
          label-for="status"
        >
          <v-select
            v-model="status"
            input-id="status"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statusOptions"
            placeholder="Select from list"
          />
        </b-form-group>
      </div>

      <!-- Footer -->
      <div class="d-flex content-sidebar-footer px-2 py-1">
        <b-button
          variant="outline-primary"
          class="mr-1"
          @click="clearAll"
        >
          Clear all
        </b-button>
        <b-button
          variant="primary"
          @click="applyFilter(hide)"
        >
          Apply filter
        </b-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BButton, BFormGroup, BFormCheckbox, BFormCheckboxGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BSidebar,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    vSelect,
  },
  model: {
    prop: 'isFilterSidebarActive',
    event: 'update:is-filter-sidebar-active',
  },
  props: {
    isFilterSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      appointmentTypeOptions: [],
      serviceTypeOptions: [],
      statusOptions: ['Active', 'Inactive'],

      selectedAppointmentTypes: [],
      selectedServiceTypes: [],
      status: null,
    }
  },
  mounted() {
    this.fetchAppointmentTypeOptions()
    this.fetchServiceTypeOptions()
  },
  methods: {
    fetchAppointmentTypeOptions() {
      this.$http.get('appointment/activity-types/respond-with/name-and-id', { params: { status: 'published' } })
        .then(response => {
          this.appointmentTypeOptions = response.data.activityTypes || []
        })
        .catch(() => {})
    },
    fetchServiceTypeOptions() {
      this.$http.get('operation/service-description-setups/respond-with/service-types')
        .then(response => {
          this.serviceTypeOptions = response.data.serviceTypes || []
        })
        .catch(() => {})
    },
    clearAll() {
      this.selectedAppointmentTypes = []
      this.selectedServiceTypes = []
      this.status = null
    },
    applyFilter(hide) {
      this.$emit('apply-filter', {
        appointmentTypes: this.selectedAppointmentTypes,
        serviceTypes: this.selectedServiceTypes,
        status: this.status,
      })
      hide()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss" scoped>
.content-sidebar-footer {
  position: sticky;
  bottom: 0;
  background-color: inherit;
  border-top: 1px solid #EBE9F1;
}
</style>
